import { AestheticMedicineExperience } from "./v1";

export type AestheticMedicineExperienceV1Type = keyof typeof AestheticMedicineExperience;

export type AestheticMedicineExperienceType = AestheticMedicineExperienceV1Type;
